import { render, staticRenderFns } from "./Talent-detail.vue?vue&type=template&id=367038c6&scoped=true&"
import script from "./Talent-detail.vue?vue&type=script&lang=js&"
export * from "./Talent-detail.vue?vue&type=script&lang=js&"
import style0 from "./Talent-detail.vue?vue&type=style&index=0&id=367038c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367038c6",
  null
  
)

export default component.exports